<template>
	<div class="ydet-page">
		<van-loading v-if="loading" class="page-loading" size="24" vertical>加载中...</van-loading>
		<template v-else>
			<!-- 反馈内容 -->
			<div class="card">
				<div class="det-head">
					<span class="type">{{ det.complaintType }}</span>
				</div>
				<div class="row"><span class="label">反馈时间</span><span class="val">{{ det.submitTime }}</span></div>
				<div class="row"><span class="label">联系方式</span><span class="val">{{ det.mobile }}</span></div>
				<div class="content-box">{{ det.content }}</div>
				<!-- 截图 -->
				<div class="imgs" v-if="det.attachs && det.attachs.length">
					<img v-for="(url, i) in det.attachs" :key="i" :src="url" @click="onPreview(i)" />
				</div>
			</div>
			<!-- 回复内容 -->
			<div class="card">
				<div class="card-title">回复内容</div>
				<div class="content-box">{{ det.handleContent || '暂未回复，请耐心等待' }}</div>
			</div>
		</template>
	</div>
</template>

<script>
	import {
		ImagePreview
	} from 'vant';

	const MOCK = false; //假数据开关,样式参考用,联调时改回 false

	//假数据按id区分:'1'已回复带图,'2'未回复无图
	const MOCK_DETAILS = {
		'1': {
			id: '1',
			complaintType: '功能异常',
			mobile: '15112347705',
			content: '缴费页面打开后一直转圈，无法加载待缴账单，切换网络也没用，重启微信后仍然存在。',
			attachs: [
				require('../../assets/grzx/topbg.png'),
				require('../../assets/grzx/head.png'),
				require('../../assets/grzx/sytp.png')
			],
			handleContent: '该问题已在最新版本修复，请更新 App 后重试；如仍有问题请随时反馈，感谢您的支持。',
			submitTime: '2026-08-18 09:32'
		},
		'2': {
			id: '2',
			complaintType: '产品建议',
			mobile: '15112347705',
			content: '希望增加电子发票的开票记录导出功能，方便报销使用。',
			attachs: [],
			handleContent: '',
			submitTime: '2026-08-17 15:47'
		}
	};

	export default {
		data() {
			return {
				loading: true,
				det: {} //反馈详情
			};
		},
		mounted() {
			this.getdata();
		},
		methods: {
			getdata() {
				if (MOCK) {
					this.mockLoad();
					return;
				}
				this.$axios.get('/api/v1/tsjy/' + this.$route.query.id).then(res => {
					this.det = res || {};
					this.loading = false;
				}).catch(() => {
					this.loading = false;
				});
			},
			//假数据,模拟接口延迟
			mockLoad() {
				setTimeout(() => {
					this.det = MOCK_DETAILS[this.$route.query.id] || MOCK_DETAILS['1'];
					this.loading = false;
				}, 500);
			},
			//预览截图
			onPreview(index) {
				ImagePreview({
					images: this.det.attachs,
					startPosition: index,
					onClose() {}
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	.ydet-page {
		min-height: 100vh;
		background: #f6f6f7;
		padding: 15px 15px 30px;
		box-sizing: border-box;
	}

	.page-loading {
		padding: 100px 0;
		text-align: center;
	}

	.card {
		background: #fff;
		border-radius: 8px;
		padding: 15px;
		margin-bottom: 10px;
	}

	.det-head {
		padding-bottom: 10px;
		border-bottom: 1px solid #f2f3f5;
		margin-bottom: 10px;

		.type {
			font-size: 16px;
			color: #323233;
			font-weight: bold;
		}
	}

	.row {
		display: flex;
		justify-content: space-between;
		font-size: 13px;
		margin-bottom: 8px;

		.label {
			color: #969799;
		}

		.val {
			color: #323233;
		}
	}

	.content-box {
		font-size: 14px;
		color: #323233;
		line-height: 22px;
		background: #f7f8fa;
		border-radius: 6px;
		padding: 10px;
		margin-top: 5px;
		word-break: break-all;
	}

	.imgs {
		display: flex;
		flex-wrap: wrap;
		margin-top: 10px;

		img {
			width: 72px;
			height: 72px;
			border-radius: 4px;
			object-fit: cover;
			margin: 0 8px 8px 0;
		}
	}

	.card-title {
		font-size: 15px;
		color: #323233;
		font-weight: bold;
		margin-bottom: 10px;
	}
</style>
